export const globalState = {
    serverDetectMobile: null,
    clientCanHandleWebp: null,
    locations: [],
    currentRegion: null,
    numberOfAjaxCallPending: 0,
};
